<div class="row">
    <mat-card appearance="outlined">
        <div class="col">
            <p>
                <ng-container *ngIf="error == false">
                    <strong>¿Seguro que quiere eliminar este mandato?</strong>
                </ng-container>
                <ng-container *ngIf="error">
                    <strong>Mandato eliminado</strong>
                </ng-container>
            </p>
            <br/>
        </div>

        <div class="text-center">
            <ng-container *ngIf="error == false">
                <button mat-stroked-button (click)="delete()" class="me-2">
                    <mat-icon>delete</mat-icon>
                    Eliminar
                </button>
            </ng-container>
            <button mat-stroked-button (click)="closeDialog()">
                <mat-icon>close</mat-icon>
                Cerrar
            </button>
        </div>
    </mat-card>
</div>